import { render } from "./CoursesView.vue?vue&type=template&id=46a3fdc2&scoped=true&ts=true"
import script from "./CoursesView.vue?vue&type=script&lang=ts"
export * from "./CoursesView.vue?vue&type=script&lang=ts"

import "./CoursesView.vue?vue&type=style&index=0&id=46a3fdc2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a3fdc2"]])

export default __exports__